import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";

export interface DigitizationMenuItem {
    children?: DigitizationMenuItem[],
    label?: string,
    path?: string,
    isVisible?: () => boolean,
    qaId?: string
}

class DigitizationMenuRegistry {
    private categories: DigitizationMenuItem[] = [
        {
            children: [
                {
                    label: 'Digitize an Asset',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewInBlockAnAssetButton),
                    path: 'ingest'
                }
            ]
        }, {
            label: 'IMPORT JOBS',
            children: [
                {
                    label: 'All Import Jobs',
                    path: 'import-jobs',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewImportJobTab)
                }
            ]
        }, {
            label: 'THE VAULT',
            children: [
                {
                    label: 'Insurance Policies',
                    path: 'insurancepolicies',
                    qaId: 'TV-Insurance Policies',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewVaultInsurancePoliciesTab),
                },
                {
                    label: 'Invoices',
                    path: 'invoices',
                    qaId: 'TV-Invoices',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewVaultInvoicesInvoiceTab),
                },
                {
                    label: 'Remittance Advice',
                    path: 'remittanceadvice',
                    qaId: 'TV-Remittance Advice',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewVaultRemittanceAdviceTab),
                },
                {
                    label: 'Payments',
                    path: 'payments',
                    qaId: 'TV-Payaments',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewVaultPaymentTab),
                },
                {
                    label: 'Credit Notes',
                    path: 'creditNotes',
                    qaId: 'TV-Credit Notes',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewVaultCreditNotesTab),
                },
                {
                    label: 'Unapplied Cash',
                    path: 'unappliedCashes',
                    qaId: 'TV-Unapplied Cashes',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewVaultUnappliedCashTab),
                }
            ]
        }, {
            label: 'CONFIGURATION',
            children: [
                {
                    label: 'Connections',
                    path: 'connections',
                    qaId: 'TV-Connections',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewConnectionsTab),
                }, 
                {
                    label: 'Import Templates',
                    path: 'import-templates',
                    qaId: 'TV-Import Templates',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewImportModelTab),
                }, 
                {
                    label: 'Validation Sets',
                    path: 'validation-rules',
                    qaId: 'TV-Validations',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewValidationRuleTab),
                }
            ]
        }, {
            label: 'SETTINGS',
            children: [
                {
                    label: 'Manage Subscriptions',
                    path: 'notificationSubscriptions',
                    qaId: 'notificationSubscriptions',
                    isVisible: () => Can(UserEntitlementCatalogs.ViewManageSubscriptionsTab),
                }
            ]
        }
    ];

    isMenuItemVisible(menuItem: DigitizationMenuItem) {
        return !menuItem.isVisible || menuItem.isVisible();
    }

    getVisibleChildren(menuItem: DigitizationMenuItem) {
        return menuItem.children ? menuItem.children.filter(child => this.isMenuItemVisible(child)) : [];
    }

    getVisibleCategories() {
        return this.categories.filter(category => category.label && category.children.filter(this.isMenuItemVisible).length > 0)
    }

    getFirstVisibleMenuItemPath() {
        var visibleMenuItems = this.categories.map(category => this.getVisibleChildren(category)).reduce((a, b) => a.concat(b));

        if (visibleMenuItems.length > 0) {
            return visibleMenuItems[0].path;
        }

        return null;
    }
}

export const DigitizationMenuRegistryInstance = new DigitizationMenuRegistry();
